import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { AuthUserGuard } from "./auth/auth-user.guard";

export const routes: Routes = [
  {
    path: 'catalog',
    data: {title: 'Catalog Browser', icon: 'sim_card'},
    canActivate: [AuthUserGuard],
    loadChildren: () => import('./pages/catalog/catalog.module').then(m => m.CatalogModule)
  },
  {
    path: 'contracts',
    data: {title: 'Contracts', icon: 'attachment'},
    canActivate: [AuthUserGuard],
    loadChildren: () => import('./pages/contracts/contracts.module').then(m => m.ContractsModule)
  },
  {
    path: 'transfer-history',
    data: {title: 'Transfer History', icon: 'assignment'},
    canActivate: [AuthUserGuard],
    loadChildren: () => import('./pages/transfer-history/transfer-history.module').then(m => m.TransferHistoryModule)
  },
  {
    path: 'contract-definitions',
    data: {title: 'Contract Definitions', icon: 'rule'},
    canActivate: [AuthUserGuard],
    loadChildren: () => import('./pages/contract-definitions/contract-definitions.module').then(m => m.ContractDefinitionsModule)
  },
  {
    path: 'policies',
    data: {title: 'Policies', icon: 'policy'},
    canActivate: [AuthUserGuard],
    loadChildren: () => import('./pages/policies/policies.module').then(m => m.PoliciesModule)
  },
  {
    path: 'asset-management',
    data: {title: 'Assets', icon: 'upload'},
    canActivate: [AuthUserGuard],
    loadChildren: () => import('./pages/assets/assets.module').then(m => m.AssetsModule)
  },
  {
    path: 'requests',
    data: {title: 'Requests', icon: 'inbox'},
    canActivate: [AuthUserGuard],
    loadChildren: () => import('./pages/requests/requests.module').then(m => m.RequestsModule)
  },
  {
    path: 'new-asset-requests',
    data: {title: 'New Asset Requests', icon: 'post_add'},
    canActivate: [AuthUserGuard],
    loadChildren: () => import('./pages/new-asset-requests/new-asset-requests.module').then(m => m.NewAssetRequestsModule)
  },
  {
    path: 'vocabularies',
    data: {title: 'Vocabularies', icon: 'book'},
    canActivate: [AuthUserGuard],
    loadChildren: () => import('./pages/vocabularies/vocabularies.module').then(m => m.VocabulariesModule)
  },
  {
    path: '', redirectTo: 'catalog', pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
